module.exports = __webpack_public_path__ + "img/Apoptosis-CRC_10X_WTA.0aaf6912.png";